// Copyright © 2024 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'
import { AnyObject } from '@movecloser/front-core'

import { AnyModule, ContentSneakPeakData } from '../../_contracts'
import { addonsRegistry } from '../../TeaserBox/TeaserBox.config'

/**
 * Base mixin for components that work with addons
 * Provides common functionality for addon component resolution and props
 */
@Component({
  name: 'AddonsMixin'
})
export class AddonsMixin extends Vue {
  /**
   * Additional props for addons
   */
  @Prop({ type: Object, required: false, default: () => ({}) })
  public readonly addonProps!: Record<string, AnyObject>

  /**
   * Gets the component name for an addon
   */
  protected getAddonComponent (addon: ContentSneakPeakData | AnyModule): string {
    // Handle case where addon might be an array instead of single module
    const module = Array.isArray(addon) ? addon[0] : addon
    return (addonsRegistry as Record<string, string>)[module?.driver] || 'div'
  }

  /**
   * Gets base props for addon component
   * This is the basic version - extend in subclasses for more specific props
   */
  protected getAddonProps (addon: ContentSneakPeakData | AnyModule): object {
    // Handle case where addon might be an array instead of single module
    const module = Array.isArray(addon) ? addon[0] : addon
    return {
      ...this.addonProps,
      module: module
    }
  }
}
